module.exports = __webpack_public_path__ + "img/importFileIcon.3146114d.svg";